import { ArrowDown2 } from "iconsax-reactjs";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const LangugeChanger = () => {
  const { i18n } = useTranslation();
  const [languageDropdown, setLanguageDropdown] = useState(false);
  const [currentLang, setCurrentLang] = useState(i18n?.language || "en");

  const languages = {
    ar: {
      label: "AR",
      name: "العربية",
      flag: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/dd/Flag_of_Oman.svg/330px-Flag_of_Oman.svg.png",
    },
    en: {
      label: "EN",
      name: "English",
      flag: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a5/Flag_of_the_United_Kingdom_%281-2%29.svg/330px-Flag_of_the_United_Kingdom_%281-2%29.svg.png",
    },
  };

  const handleLangChange = (lang) => {
    setCurrentLang(lang);
    setLanguageDropdown(false);
    i18n.changeLanguage(lang);
  };
  return (
    <div className="relative">
      <button
        onClick={() => setLanguageDropdown(!languageDropdown)}
        className="flex items-center space-x-1 gap-1 text-sm font-semibold text-green-800 cursor-pointer"
      >
        <span>{languages[currentLang].label}</span>
        <img
          src={languages[currentLang].flag}
          className="w-4 h-4 rounded-full"
          alt="flag"
        />
        <ArrowDown2 size={16} />
      </button>

      {languageDropdown && (
        <div className="absolute left-0 rtl:right-0 mt-2 w-32 bg-white shadow-md rounded z-10">
          {Object.entries(languages).map(([code, { name, flag }]) => (
            <div
              key={code}
              onClick={() => handleLangChange(code)}
              className="flex items-center gap-2 px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer"
            >
              <img src={flag} className="w-4 h-4 rounded-full" />

              {name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LangugeChanger;
